import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '@/components/NavBar';
import MainFooter from '@/components/MainFooter';
import NewsletterHero from '@/components/newsletter/NewsletterHero';
import NewsletterTestimonials from '@/components/newsletter/NewsletterTestimonials';
import NewsletterPastIssues from '@/components/newsletter/NewsletterPastIssues';
import NewsletterSubscribe from '@/components/newsletter/NewsletterSubscribe';

const TalentTalesNewsletter = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Helmet>
        <title>The Talent Tales Newsletter | Cutshort</title>
        <meta name="description" content="Get real insights from thousands of hiring companies and millions of premium candidates. Subscribe to The Talent Tales newsletter - sent with love every Friday." />
        <meta property="og:title" content="The Talent Tales Newsletter | Cutshort" />
        <meta property="og:description" content="Get real insights from thousands of hiring companies and millions of premium candidates. Subscribe to The Talent Tales newsletter - sent with love every Friday." />
        <meta property="og:image" content="/lovable-uploads/63ba4f2f-b684-458f-9cc2-964a2619d838.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@cutshortHQ" />
        <meta name="twitter:image" content="/lovable-uploads/63ba4f2f-b684-458f-9cc2-964a2619d838.png" />
      </Helmet>
      
      <NavBar />
      <main>
        <NewsletterHero />
        <NewsletterTestimonials />
        <NewsletterPastIssues />
        <NewsletterSubscribe />
      </main>
      <MainFooter />
    </div>
  );
};

export default TalentTalesNewsletter;


